import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner8.png'
import _imports_2 from '../../assets/performance/bannerQF.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3177c39d")

_pushScopeId("data-v-3177c39d")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = { id: "perf_report" }
const _hoisted_17 = { class: "spacName" }
const _hoisted_18 = {
  key: 0,
  class: "banner",
  src: _imports_1,
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  class: "banner",
  src: _imports_2,
  alt: ""
}
const _hoisted_20 = { class: "mainContent" }
const _hoisted_21 = { class: "spacName" }
const _hoisted_22 = { class: "gameTable" }
const _hoisted_23 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_24 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_29 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "自动化深度性能测试")
], -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_31 = { class: "corePerformance" }
const _hoisted_32 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试概况")
], -1)
const _hoisted_33 = { class: "spacName" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "当前版本：", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold"} }, "对比版本：", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_37 = { class: "game_cpu" }
const _hoisted_38 = /*#__PURE__*/_createVNode("tr", { style: {"font-weight":"bold"} }, [
  /*#__PURE__*/_createVNode("td", null, "机型"),
  /*#__PURE__*/_createVNode("td", null, "场景"),
  /*#__PURE__*/_createVNode("td", null, "场景"),
  /*#__PURE__*/_createVNode("td", null, "风险"),
  /*#__PURE__*/_createVNode("td", null, "测试概况")
], -1)
const _hoisted_39 = { style: {"background":"#fff"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" FrameTime")
const _hoisted_41 = { style: {"padding":"0 2px"} }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("对比上次(")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("),对应的FPS")
const _hoisted_44 = { style: {"padding":"0 2px"} }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("对比上次(")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_47 = { style: {"background":"#fff"} }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" CPU Total")
const _hoisted_49 = { style: {"padding":"0 0px 0 4px"} }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("对比上次(")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("对比上次(")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_54 = {
  key: 0,
  style: {"background":"#fff"}
}
const _hoisted_55 = { style: {"margin-left":"5px"} }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("对比上次(")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_58 = { class: "corePerformance" }
const _hoisted_59 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("二、CPU Usage")
], -1)
const _hoisted_60 = { class: "spacName" }
const _hoisted_61 = { style: {"font-size":"14px","color":"#7c7d86","font-weight":"bold"} }
const _hoisted_62 = { class: "gameTable_cpu" }
const _hoisted_63 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_64 = { class: "corePerformance" }
const _hoisted_65 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、线程耗时")
], -1)
const _hoisted_66 = { class: "spacName" }
const _hoisted_67 = { style: {"font-size":"14px","color":"#7c7d86","font-weight":"bold"} }
const _hoisted_68 = { class: "gameTable_cpu" }
const _hoisted_69 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("四、主要模块耗时")
], -1)
const _hoisted_71 = { class: "spacName" }
const _hoisted_72 = { style: {"font-size":"14px","color":"#7c7d86","font-weight":"bold"} }
const _hoisted_73 = { class: "corePerformance" }
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("五、严重掉帧堆栈")
  ])
], -1)
const _hoisted_75 = { class: "spacName" }
const _hoisted_76 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_77 = { style: {"font-size":"14px","color":"#7c7d86","font-weight":"bold"} }
const _hoisted_78 = { style: {"margin-top":"20px"} }
const _hoisted_79 = { class: "frames-info" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 选中 ")
const _hoisted_81 = { class: "frames-num" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 帧， 帧序列 ")
const _hoisted_83 = { class: "frames-num" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("， 时长 ")
const _hoisted_85 = { class: "frames-num" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" ms， 平均帧率 ")
const _hoisted_87 = { class: "frames-num" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" fps， 平均每帧 ")
const _hoisted_89 = { class: "frames-num" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" ms/frame ")
const _hoisted_91 = {
  key: 0,
  class: "frames-info",
  style: {"margin-top":"10px"}
}
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" 选中时间段 ")
const _hoisted_93 = { class: "frames-num" }
const _hoisted_94 = { style: {"display":"flex","justify-content":"space-between","margin":"20px 0"} }
const _hoisted_95 = {
  class: "pos",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_96 = /*#__PURE__*/_createVNode("div", {
  id: "analyse",
  style: {"height":"416px","width":"100%"}
}, null, -1)
const _hoisted_97 = { style: {"width":"240px"} }
const _hoisted_98 = { class: "ellipsis" }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_101 = { style: {"width":"50%","margin-right":"20px"} }
const _hoisted_102 = { style: {"width":"5.5%"} }
const _hoisted_103 = { style: {"margin-left":"auto","width":"35%"} }
const _hoisted_104 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_106 = {
  id: "chart1",
  style: {"margin-bottom":"20px"}
}
const _hoisted_107 = /*#__PURE__*/_createVNode("div", {
  id: "chart",
  class: "chart-area"
}, null, -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("六、主要指标趋势")
], -1)
const _hoisted_109 = {
  style: {"color":"#7c7d86"},
  class: "labelStyle"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        class: "version_input",
                        label: "当前版本"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.dataConsumeOptions.version,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                            placeholder: "请选择",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.versionChange(['version', 'scene', 'thread', 'so'], true)
                  )),
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.version_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.chinese,
                                  value: item.chinese
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试机型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.versionChange(['scene'], true))),
                            modelValue: _ctx.dataConsumeOptions.device,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options_old, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.device_name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.versionChange(['scene'], true))),
                            modelValue: _ctx.dataConsumeOptions.scene,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.scene_id,
                                  label: item.chinese,
                                  value: item.scene_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.affirmBtn()))
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, {
                    model: _ctx.dataConsumeOptions,
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        class: "version_input",
                        label: "对比版本"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.versionChange([], true))),
                            modelValue: _ctx.dataConsumeOptions.old_verson,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.chinese,
                                  value: item.chinese
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "thread_margin",
                        label: "线程"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.versionChange(['so'], false))),
                            modelValue: _ctx.dataConsumeOptions.thread,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataConsumeOptions.thread = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threadOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "so_margin",
                        label: "so"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.versionChange([], false))),
                            modelValue: _ctx.dataConsumeOptions.so,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataConsumeOptions.so = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_cos, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_4,
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      (_ctx.localProject != 7)
                        ? (_openBlock(), _createBlock("img", _hoisted_18))
                        : (_openBlock(), _createBlock("img", _hoisted_19))
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("table", _hoisted_22, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_23, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.basic?.project_icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_24, " 【" + _toDisplayString(_ctx.get_core_data.basic?.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_25,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.basic?.version), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_26,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.basic?.date), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_27,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.basic?.user), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_28,
                              _createVNode("span", {
                                class: 
                            JSON.stringify(_ctx.text_list) != '{}'
                              ? 'com_risk_red'
                              : 'com_risk_green'
                          
                              }, _toDisplayString(JSON.stringify(_ctx.text_list) != "{}"
                              ? "高风险"
                              : "低风险"), 3)
                            ]),
                            _hoisted_29,
                            _createVNode("td", null, [
                              _hoisted_30,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.basic.platform), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.dataLoading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode("div", _hoisted_33, [
                          _createVNode("div", null, [
                            _hoisted_34,
                            _createTextVNode(_toDisplayString(_ctx.get_core_data.basic.version) + " ", 1),
                            _hoisted_35,
                            _createTextVNode(_toDisplayString(_ctx.get_core_data.basic.old_version), 1)
                          ]),
                          _hoisted_36,
                          _createVNode("table", _hoisted_37, [
                            _hoisted_38,
                            _createVNode("tr", _hoisted_39, [
                              _createVNode("td", {
                                rowspan: _ctx.thread_list.length > 0 ? 3 : 2
                              }, _toDisplayString(_ctx.get_core_data.basic.device_name +
                            "-" +
                            _ctx.get_core_data.basic.device_level), 9, ["rowspan"]),
                              _createVNode("td", {
                                rowspan: _ctx.thread_list.length > 0 ? 3 : 2
                              }, _toDisplayString(_ctx.get_core_data.basic.scene), 9, ["rowspan"]),
                              _createVNode("td", {
                                rowspan: _ctx.thread_list.length > 0 ? 3 : 2
                              }, _toDisplayString(_ctx.get_core_data.overview[0]?.label_name), 9, ["rowspan"]),
                              _createVNode("td", {
                                rowspan: _ctx.thread_list.length > 0 ? 3 : 2
                              }, [
                                _createVNode("span", {
                                  class: 
                              JSON.stringify(_ctx.text_list) != '{}'
                                ? 'com_risk_red'
                                : 'com_risk_green'
                            
                                }, _toDisplayString(JSON.stringify(_ctx.text_list) != "{}"
                                ? "高风险"
                                : "低风险"), 3)
                              ], 8, ["rowspan"]),
                              _createVNode("td", null, [
                                _createVNode("div", null, [
                                  _hoisted_40,
                                  _createVNode("span", _hoisted_41, _toDisplayString(_ctx.get_core_data.func_list?.data[0]?.list[0]
                                ?.event_count), 1),
                                  _hoisted_42,
                                  _createVNode("span", {
                                    span: "",
                                    style: 
                                'color:' +
                                _ctx.com_num_color1(
                                  _ctx.get_core_data.func_list?.data[0]?.list[0]
                                    ?.event_count,
                                  _ctx.get_core_data.func_list?.data[0].list[0]
                                    ?.old_event_count,
                                  'thread',
                                  'single_frame_time'
                                )
                              
                                  }, _toDisplayString(_ctx.getNum(
                                  _ctx.get_core_data.func_list?.data[0]?.list[0]
                                    ?.event_count,
                                  _ctx.get_core_data.func_list?.data[0].list[0]
                                    ?.old_event_count
                                )), 5),
                                  _hoisted_43,
                                  _createVNode("span", _hoisted_44, _toDisplayString(_ctx.get_core_data.overview[0]?.new?.FPS), 1),
                                  _hoisted_45,
                                  _createVNode("span", {
                                    style: 
                                'color:' +
                                _ctx.com_num_color1(
                                  _ctx.get_core_data.overview[0]?.new?.FPS,
                                  _ctx.get_core_data.overview[0]?.old?.FPS,
                                  'thread',
                                  'FPS'
                                )
                              
                                  }, _toDisplayString(_ctx.getNum(
                                  _ctx.get_core_data.overview[0]?.new?.FPS,
                                  _ctx.get_core_data.overview[0]?.old?.FPS
                                )), 5),
                                  _hoisted_46
                                ])
                              ])
                            ]),
                            _createVNode("tr", _hoisted_47, [
                              _createVNode("td", null, [
                                _hoisted_48,
                                _createVNode("span", _hoisted_49, _toDisplayString(_ctx.get_core_data.cpu_usage_list?.[0]?.new
                              ?.avg_cpu_total), 1),
                                _hoisted_50,
                                _createVNode("span", null, _toDisplayString(_ctx.getNum(
                              _ctx.get_core_data.cpu_usage_list?.[0]?.new
                                ?.avg_cpu_total,
                              _ctx.get_core_data.cpu_usage_list?.[0]?.old
                                ?.avg_cpu_total
                            )), 1),
                                _hoisted_51,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_list, (item) => {
                                  return (_openBlock(), _createBlock("div", {
                                    style: {"margin-right":"4px"},
                                    key: item.name
                                  }, [
                                    _createTextVNode(_toDisplayString(item.name.replace("%", "")), 1),
                                    _createVNode("span", {
                                      style: 
                                'padding: 0 0px 0 4px;color:' +
                                _ctx.com_num_color5(item.new, 'cpu', item.name)
                              
                                    }, _toDisplayString(item.new + "%"), 5),
                                    _hoisted_52,
                                    _createVNode("span", {
                                      style: 
                                'color:' +
                                _ctx.com_num_color3(
                                  item.new,
                                  item.old,
                                  'cpu',
                                  item.name
                                )
                              
                                    }, _toDisplayString(_ctx.getNum(item.new, item.old)), 5),
                                    _hoisted_53
                                  ]))
                                }), 128))
                              ])
                            ]),
                            (_ctx.thread_list.length > 0)
                              ? (_openBlock(), _createBlock("tr", _hoisted_54, [
                                  _createVNode("td", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_list, (item, index) => {
                                      return (_openBlock(), _createBlock("div", {
                                        style: {"margin-right":"4px"},
                                        key: index
                                      }, [
                                        _createTextVNode(_toDisplayString(index + 1) + "、" + _toDisplayString(item.name), 1),
                                        _createVNode("span", _hoisted_55, _toDisplayString(typeof item.list[0].event_count == "number"
                                ? item.list[0].event_count.toFixed(2)
                                : "--"), 1),
                                        _hoisted_56,
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_num_color(
                                  item.list[0].event_count,
                                  item.list[0].old_event_count,
                                  item.type,
                                  true
                                )
                              
                                        }, _toDisplayString(_ctx.getNum(
                                  item.list[0].event_count,
                                  item.list[0].old_event_count
                                )), 5),
                                        _hoisted_57
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("a", {
                              target: "_blank",
                              href: _ctx.get_url(_ctx.get_core_data.basic.url)
                            }, ">>更多详细数据请在GameRobot平台查看", 8, ["href"])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createVNode("div", _hoisted_60, [
                          _createVNode("p", _hoisted_61, _toDisplayString(_ctx.get_core_data.basic.device_name +
                        "-" +
                        _ctx.get_core_data.basic.scene), 1),
                          _withDirectives(_createVNode("table", _hoisted_62, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _hoisted_63,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                                  return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                                }), 128))
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.cpu_usage_list, (v) => {
                                return (_openBlock(), _createBlock("tr", { key: v }, [
                                  _createVNode("td", null, _toDisplayString(v.label), 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, [
                                      _createVNode("span", {
                                        style: 
                                'color:' +
                                _ctx.com_num_color5(
                                  v.new[item.value],
                                  'cpu',
                                  item.name
                                )
                              
                                      }, _toDisplayString(v.new[item.value]), 5),
                                      _createVNode("span", {
                                        style: 
                                'color:' +
                                _ctx.com_num_color3(
                                  v.new[item.value],
                                  v.old[item.value],
                                  'cpu',
                                  item.name
                                )
                              
                                      }, "(" + _toDisplayString(_ctx.getNum(v.new[item.value], v.old[item.value])) + ")", 5)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ], 512), [
                            [_directive_loading, _ctx.dataLoading]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _createVNode("div", _hoisted_66, [
                          _createVNode("p", _hoisted_67, _toDisplayString(_ctx.get_core_data.basic.device_name +
                        "-" +
                        _ctx.get_core_data.basic.scene), 1),
                          _withDirectives(_createVNode("table", _hoisted_68, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _hoisted_69,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (item) => {
                                  return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(_ctx.getChinese(item)), 1))
                                }), 128))
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.overview, (v) => {
                                return (_openBlock(), _createBlock("tr", { key: v }, [
                                  _createVNode("td", null, _toDisplayString(v.label_name), 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, [
                                      _createTextVNode(_toDisplayString(v.new[item]), 1),
                                      _createVNode("span", {
                                        style: 
                                'color:' +
                                _ctx.com_num_color1(
                                  v.new[item],
                                  v.old[item],
                                  'thread',
                                  item
                                )
                              
                                      }, "(" + _toDisplayString(_ctx.getNum(v.new[item], v.old[item])) + ")", 5)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ], 512), [
                            [_directive_loading, _ctx.dataLoading]
                          ])
                        ])
                      ]),
                      _createVNode("div", null, [
                        _hoisted_70,
                        _createVNode("div", _hoisted_71, [
                          _createVNode("p", _hoisted_72, _toDisplayString(_ctx.get_core_data.basic.scene), 1),
                          _withDirectives(_createVNode(_component_el_table, {
                            size: "mini",
                            border: "",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            "cell-style": _ctx.cellStyle,
                            data: _ctx.get_core_data.func_list.data
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "800",
                                "show-overflow-tooltip": true,
                                label: "线程模块"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: 
                              'margin-left:' + _ctx.depth(scope.row.depth) + 'px'
                            
                                  }, _toDisplayString(scope.row.name), 5)
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.func_list
                          .label_list, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  align: "center",
                                  label: item,
                                  key: index
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, { label: "耗时" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(typeof scope.row.list[index].event_count ==
                              "number"
                                ? scope.row.list[index].event_count.toFixed(2)
                                : "--"), 1),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_num_color(
                                  scope.row.list[index].event_count,
                                  scope.row.list[index].old_event_count,
                                  scope.row.type,
                                  true
                                )
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(
                                  scope.row.list[index].event_count,
                                  scope.row.list[index].old_event_count
                                )) + ")", 5)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_table_column, { label: "比例" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(typeof scope.row.list[index].rate == "number"
                                ? scope.row.list[index].rate.toFixed(2) + "%"
                                : "--"), 1),
                                        _createVNode("span", {
                                          style: 
                                'color:' +
                                _ctx.com_num_color(
                                  scope.row.list[index].rate,
                                  scope.row.list[index].old_rate,
                                  scope.row.type,
                                  false
                                )
                              
                                        }, "(" + _toDisplayString(_ctx.getNum(
                                  scope.row.list[index].rate,
                                  scope.row.list[index].old_rate
                                ) != "--"
                                  ? _ctx.getNum(
                                      scope.row.list[index].rate,
                                      scope.row.list[index].old_rate
                                    )
                                  : "--") + ")", 5)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["cell-style", "data"]), [
                            [_directive_loading, _ctx.dataLoading]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _createVNode("div", _hoisted_75, [
                          _createVNode("div", _hoisted_76, [
                            _createVNode("p", _hoisted_77, _toDisplayString(_ctx.get_core_data.basic.device_name +
                          "-" +
                          _ctx.get_core_data.basic.scene), 1),
                            _createVNode("div", null, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode("a", {
                                    style: {"color":"#fff","text-decoration":"none"},
                                    href: _ctx.los(_ctx.flame_url?.url),
                                    download: ""
                                  }, "离线文件下载", 8, ["href"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode("div", _hoisted_78, [
                            _createVNode("p", _hoisted_79, [
                              _hoisted_80,
                              _createVNode("span", _hoisted_81, _toDisplayString(_ctx.framesInfo.framesCount * _ctx.frame_merge_size), 1),
                              _hoisted_82,
                              _createVNode("span", _hoisted_83, _toDisplayString(_ctx.framesInfo.start * _ctx.frame_merge_size) + "-" + _toDisplayString((_ctx.framesInfo.end + 1) * _ctx.frame_merge_size), 1),
                              _hoisted_84,
                              _createVNode("span", _hoisted_85, _toDisplayString((_ctx.framesInfo.sumTime * _ctx.frame_merge_size).toFixed(2)), 1),
                              _hoisted_86,
                              _createVNode("span", _hoisted_87, _toDisplayString(_ctx.framesInfo.FPS), 1),
                              _hoisted_88,
                              _createVNode("span", _hoisted_89, _toDisplayString(_ctx.framesInfo.frameTime), 1),
                              _hoisted_90
                            ]),
                            (_ctx.selectShow)
                              ? (_openBlock(), _createBlock("p", _hoisted_91, [
                                  _hoisted_92,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList, (item, index) => {
                                    return (_openBlock(), _createBlock("span", { key: index }, [
                                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                      _createVNode("span", _hoisted_93, _toDisplayString(item.sum.toFixed(2)), 1),
                                      _createVNode("span", null, _toDisplayString(index == _ctx.selectList?.length - 1 ? "" : "，"), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_94, [
                            _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"68%"} }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_95, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: index,
                                      style: {
                              background: item.color,
                              width: item.width,
                            }
                                    }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                  }), 128))
                                ]),
                                _hoisted_96
                              ]),
                              _: 1
                            }, 512), [
                              [_directive_loading, _ctx.threadLoading]
                            ]),
                            _createVNode(_component_el_card, { style: {"width":"31%"} }, {
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_table, {
                                  border: "",
                                  class: "my-table",
                                  data: _ctx.tableList_new,
                                  key: _ctx.itemKey
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, { label: "搜索" }, {
                                      header: _withId(() => [
                                        _createVNode("div", _hoisted_97, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.serch,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.serch = $event)),
                                            onChange: _ctx.serchChange,
                                            size: "mini",
                                            width: "200",
                                            placeholder: "输入名称关键字搜索"
                                          }, null, 8, ["modelValue", "onChange"])
                                        ])
                                      ]),
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          "show-overflow-tooltip": "false",
                                          prop: "name",
                                          label: "函数"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", _hoisted_98, _toDisplayString(scope.row.name), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          width: "80",
                                          label: "耗时"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.time), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          width: "80",
                                          label: "占比"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.rate) + "%", 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          width: "70",
                                          label: "趋势"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode(_component_el_checkbox, {
                                              modelValue: scope.row.check,
                                              "onUpdate:modelValue": ($event: any) => (scope.row.check = $event),
                                              onChange: ($event: any) => (
                                    _ctx.checkChange(
                                      scope.row.check,
                                      scope.row.id,
                                      scope.row.name
                                    )
                                  )
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]), [
                                  [_directive_loading, _ctx.stackLoading]
                                ]),
                                _createVNode(_component_el_pagination, {
                                  class: "page_count",
                                  style: {"text-align":"right","margin-top":"10px"},
                                  currentPage: _ctx.currentPage,
                                  "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => (_ctx.currentPage = $event)),
                                  "pager-count": 0,
                                  "page-size": "10",
                                  total: _ctx.total,
                                  layout: "total, prev, next,jumper",
                                  onCurrentChange: _ctx.handleCurrentChange
                                }, null, 8, ["currentPage", "total", "onCurrentChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _withDirectives(_createVNode(_component_el_table, {
                        id: "func",
                        "row-style": _ctx.tableRowClassName,
                        class: "customer-table",
                        "default-expand-all": _ctx.isExpand,
                        data: _ctx.stackData_all,
                        size: "small",
                        "header-cell-style": {
                    background: '#1B1B1B',
                    color: '#B5B5B5',
                    border: '0',
                    padding: '1px,0',
                    height: '10px',
                  },
                        ref: "table",
                        style: {"width":"100%","margin-bottom":"20px"},
                        "row-key": "id"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              "show-overflow-tooltip": true,
                              key: index,
                              index: index,
                              label: item.label,
                              width: item.label == 'func_name' ? '800' : '',
                              title: item.prop
                            }, {
                              default: _withId((scope) => [
                                (item.prop != 'rate')
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      id: scope.row.id
                                    }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_99, _toDisplayString(scope.row[item.prop] + "%"), 1))
                              ]),
                              _: 2
                            }, 1032, ["index", "label", "width", "title"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["row-style", "default-expand-all", "data"]), [
                        [_directive_loading, _ctx.stackLoading]
                      ]),
                      _createVNode("div", _hoisted_100, [
                        _createVNode("div", _hoisted_101, [
                          _createVNode(_component_el_input, {
                            size: "mini",
                            modelValue: _ctx.func_name,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.func_name = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_102, [
                          _createVNode(_component_el_input, {
                            size: "mini",
                            modelValue: _ctx.func_rate,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.func_rate = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_103, [
                          _createVNode("div", _hoisted_104, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"20px"},
                              modelValue: _ctx.flame_serch,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.flame_serch = $event)),
                              placeholder: "搜索",
                              "prefix-icon": "el-icon-search",
                              size: "mini"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.recordSearch()))
                            }, {
                              default: _withId(() => [
                                _hoisted_105
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_106, [
                        _hoisted_107
                      ], 512), [
                        [_directive_loading, _ctx.stackLoading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_108,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target, (item) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                            class: "FPStrend5",
                            key: item
                          }, {
                            default: _withId(() => [
                              _createVNode("p", null, [
                                _createVNode("span", _hoisted_109, _toDisplayString(item.title === "模块耗时趋势"
                          ? item.title +
                            "-" +
                            _ctx.dataConsumeOptions.thread +
                            "-" +
                            _ctx.get_core_data.basic.device_name +
                            "-" +
                            _ctx.get_core_data.basic.scene
                          : item.title +
                            "-" +
                            _ctx.get_core_data.basic.device_name +
                            "-" +
                            _ctx.get_core_data.basic.scene), 1)
                              ]),
                              _createVNode("div", {
                                id: item.value,
                                style: {"height":"350px"}
                              }, null, 8, ["id"])
                            ]),
                            _: 2
                          }, 1536)), [
                            [_directive_loading, _ctx.dataLoading]
                          ])
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})